/**
 * Scopes an order search to Non-ABD (standard, no appointment) shipments.
 * Uses `ne true` rather than `eq false` so older orders written before the
 * `appointdeliveryRequired` flag existed (field missing) are still included.
 */
export const NON_ABD_FILTER = { field: 'appointdeliveryRequired', operator: 'ne', value: true };

/**
 * `/order/search` defaults to sorting by `_id`, which makes Mongo walk the whole orders `_id` index
 * (mostly D2C) to find 20 non-ABD B2B rows. That took 20-27s on prod. Sorting by `awbRegisteredDate`
 * inside a bounded window uses an existing awbRegisteredDate index instead: 21 docs read, ~2ms.
 */
export const NON_ABD_SORT = { field: 'awbRegisteredDate', direction: 'DESC' };
export const NON_ABD_DEFAULT_WINDOW_DAYS = 90;
/** Cap for the "AWB Not Generated" tab badge count (orders with no awbRegisteredDate yet). */
export const PENDING_AWB_LIMIT = 100;

/** Tabs on the Non-ABD page; AWB Generated is the default. */
export const AWB_TAB = Object.freeze({ GENERATED: 'generated', PENDING: 'pending' });
